export const ONLINE_CHAT_VENDOR_SCRIPT_ID = 'simplewine-online-chat-script';
